import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { FetchCurrency } from '../actions/currency';
import { FetchErrors } from '../actions/utils';
import { Route, Switch, Router } from 'react-router-dom';
import createBrowserHistory from 'history/createBrowserHistory';
import lazysizes from 'lazysizes';
import 'lazysizes/plugins/attrchange/ls.attrchange';
import 'lazysizes/plugins/respimg/ls.respimg';

import Search from './search/search';
import Basket from './basket/basket';
import ProductBasket from './basket/productbasket';
import Payment from './payment/payment';
import Confirmation from './confirmation/confirmation';
import GenericError from './error/genericerror';
import WithError from './error/withError';
import AnalyticsTracking from '../helpers/AnalyticsTracking';
import Cookies from 'js-cookie';

export const history = createBrowserHistory();
const entries = require('object.entries');
const values = require('object.values');
const queryString = require('query-string');
require('classlist-polyfill');

class App extends PureComponent {


  componentDidMount(){

    //Scroll window to top
    window.scrollTo(0, 0);

    //Initialise image lazy loading
    lazysizes.init();

    //Entries, values shim for unsupported browsers
    if (!Object.entries) { entries.shim();}
    if (!Object.values) { values.shim(); }


    //Fetch currency data and default to fallback if the currency API fails
    this.props.FetchCurrency();

    //Set cookie from querystring
    const appIdQuery = (queryString.parse(window.location.search).affiliate_id !== undefined) ? queryString.parse(window.location.search).affiliate_id : "";
    if(appIdQuery !== "") Cookies.set('affiliate_id', appIdQuery, { expires: 30, domain: process.env.REACT_APP_COOKIE_DOMAIN, hostOnly: false });

  }


  componentDidUpdate(prevProps, prevState){
    const {currency, FetchErrors } = this.props;
    FetchErrors(currency.iso_currency_code);
  }


  render() {
    return (
      <Router history={history}>
        <React.Fragment>
          <AnalyticsTracking history={history}/>
          <Switch>
            <Route exact path="/" component={Search} />
            <Route path="/basket/:tourID/:year?/:month?/:day?" component={Basket}/> {/* BOOKING.BUSABOUT */}
            <Route path="/product/basket/:tourID/:year?/:month?/:day?" component={ProductBasket}/>  {/* PRODUCTS-PAGE */}
            <Route path="/paymentdetails/:bookingguid?/:cyoa?" component={Payment}/>
            <Route path="/confirmation/:bookingguid?/:bookingstatus?/:paymentid?" component={Confirmation}/>
            <Route path="/paymenterror/:bookingguid?/:bookingstatus?/:paymentid?" component={WithError(GenericError, 'paymenterror')}/>
            <Route path="/500" component={WithError(GenericError, '500')}/>
            <Route component={WithError(GenericError, '404')} />
          </Switch>
        </React.Fragment>
      </Router>
    );
  }
}


function mapStateToProps(state){
  return{
    currency:state.currency
  }
}


function mapDispatchToProps(dispatch){
  return bindActionCreators({
    FetchCurrency,
    FetchErrors
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./src/components/app.js